import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=185b862d&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185b862d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('185b862d')) {
      api.createRecord('185b862d', component.options)
    } else {
      api.reload('185b862d', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=185b862d&scoped=true&", function () {
      api.rerender('185b862d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20obWn0Xya0Tn/JS/comp/SearchFilterTokens.vue"
export default component.exports